import { PageWrapper } from "../page-wrapper";
import { Skeleton } from "../ui/skeleton";

interface FormSkeletonProps {
  title: string;
  description?: string;
  sections?: number;
}

export function FormSkeleton({
  title,
  description,
  sections = 2,
}: FormSkeletonProps) {
  return (
    <PageWrapper description={description} title={title}>
      <div className="space-y-6">
        {Array.from({ length: sections }).map((_, sectionIndex) => (
          <div
            className="border-border bg-background rounded-lg border p-6"
            key={`section-${sectionIndex.toString()}`}
          >
            {/* Section title */}
            <div className="border-border mb-6 border-b pb-4">
              <Skeleton className="mb-2 h-6 w-48" />
              <Skeleton className="h-4 w-96" />
            </div>

            {/* Form fields */}
            <div className="space-y-6">
              {Array.from({ length: 3 }).map((_field, fieldIndex) => (
                <div
                  className="space-y-2"
                  key={`section-${sectionIndex.toString()}-field-${fieldIndex.toString()}`}
                >
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-10 w-full" />
                </div>
              ))}
            </div>

            {/* Action buttons */}
            {sectionIndex === sections - 1 && (
              <div className="border-border mt-6 flex gap-3 border-t pt-6">
                <Skeleton className="h-10 w-24" />
                <Skeleton className="h-10 w-24" />
              </div>
            )}
          </div>
        ))}
      </div>
    </PageWrapper>
  );
}
